import React, { FC, useContext } from "react";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import ReactLoading from "react-loading";

export const LoadingModal: FC = () => {
  const ctx = useContext(LoadingModalContext);

  return (
    <>
      {ctx.isLoading && ctx.activeButtonId === "" ? (
        <aside className="loading-modal">
          <ReactLoading
            className="ic-load"
            type="spokes"
            width={0}
            height={0}
          />
        </aside>
      ) : (
        <></>
      )}
    </>
  );
};
